var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"breadcrumb"}},_vm._l((_vm.stack),function(item,index){return _c('a',{key:index,on:{"click":function($event){return _vm.changeView(item.view)}}},[_vm._v("\n        "+_vm._s(item.name)+"\n    ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }